"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var initPaymentErrorStyles_1 = require("./initPaymentErrorStyles");
var OutOfStockPaymentError = function () {
    var styles = initPaymentErrorStyles_1.default();
    return (<core_1.Typography data-test="checkout:webpay:out_of_stock" variant="subtitle2">
      <Translation_1.default className={styles.translation} id={'trans__checkout__payment_page__out_of_stock_message'}/>
    </core_1.Typography>);
};
exports.default = OutOfStockPaymentError;
